<section class="cz-extend-logout-dialog">
    <div mat-dialog-title class="mat-dialog-title">
        <div class="row">
            <div class="col-xs-10">
                <h3 class="title">{{'$inactivity_title'| translate}} </h3>
            </div>
            <div class="col-xs-2 end-xs">

            </div>
        </div>
    </div>
    <mat-dialog-content>
        <p class="description" [innerHTML]="'$inactivity_desc'| translate"></p>
    </mat-dialog-content>
    <div mat-dialog-actions>
        <div class="col-xs-8">
            <button mat-stroked-button class="del-btn "  mat-dialog-close (click)="logout()">{{'$btn_logout'| translate}}</button>
        </div>
        <div class="col-xs-4 text-right end-xs">
            <button mat-flat-button class="del-btn" color="primary" mat-dialog-close (click)="onExtendClicked">{{'$btn_remain_logged_in'| translate}}</button>
        </div>
        
    </div>
</section>